import { Component } from '@angular/core';
import { NavParams, Platform } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-trashbulkmenu-modal',
    templateUrl: './trashbulkmenu-modal.page.html',
    styleUrls: ['./trashbulkmenu-modal.page.scss'],
})
export class TrashbulkmenuModalPage
{
    private obj: any;

    constructor(
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'trashbulkmenu-modal', value: null});
        this.obj = this.navParams.data.obj;
    }

    async bulkmenuClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'trashbulkmenu-modal', value: null});
    }
}
